export default __webpack_public_path__ + "static/dash-3-3f99d17d3cc5f0f4a00104123b8ca452.png";